import React from "react";
import { LOGO_URL } from "../data/site";

export default function Logo({
  variant = "dark",
  withText = true,
  size = 44,
  textSize = "base",
  className = "",
}) {
  const textColor = variant === "light" ? "text-white" : "text-[#0B5D1E]";
  const sublabel = variant === "light" ? "text-[#14803C] font-semibold" : "text-[#0B5D1E]/70 font-semibold";

  const titleCls = {
    base: "text-base sm:text-lg",
    lg: "text-xl sm:text-2xl",
    xl: "text-2xl sm:text-3xl",
    "2xl": "text-3xl sm:text-4xl",
  }[textSize] || "text-base sm:text-lg";

  const subCls = {
    base: "text-[10px] sm:text-xs",
    lg: "text-xs sm:text-sm",
    xl: "text-xs sm:text-sm",
    "2xl": "text-sm",
  }[textSize] || "text-[10px] sm:text-xs";

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src={LOGO_URL}
        alt="Grand Kasai Nsanga Lubangu logo"
        width={size}
        height={size}
        className="rounded-full object-cover shadow-sm ring-1 ring-black/5"
        style={{ width: size, height: size }}
      />
      {withText && (
        <div className="leading-tight">
          <div className={`font-heading font-bold ${titleCls} ${textColor}`}>
            Grand Kasaï
          </div>
          <div className={`font-body tracking-widest uppercase ${subCls} ${sublabel}`}>
            Nsanga Lubangu · GKNL
          </div>
        </div>
      )}
    </div>
  );
}
